function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "menu-aspiration",
  "data-name": "Group 26683",
  transform: "translate(-2.94 -5.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_24375",
  "data-name": "Path 24375",
  d: "M20.3,19.584H4V6",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_24376",
  "data-name": "Path 24376",
  d: "M18.943,8l-6.792,6.792L9.434,12.075,4,17.509",
  transform: "translate(0 -0.642)",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_24377",
  "data-name": "Path 24377",
  d: "M24.4,11.4V8H21",
  transform: "translate(-5.454 -0.642)",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

function SvgMenuAspiration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.111,
    height: 15.084,
    viewBox: "0 0 18.111 15.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAspiration);
export default __webpack_public_path__ + "static/media/menu-aspiration.4a4e2360.svg";
export { ForwardRef as ReactComponent };